module.exports = __webpack_public_path__ + "img/prev.c0769ced.svg";